import {Component, OnInit, Inject, DestroyRef, inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {LocationSetService} from '@emm/core/services/location-set.service';
import {TagService} from '@emm/core/services/tag.service';

@Component({
    selector: 'emm-add-location-set-dialog',
    styleUrls: ['./add-location-set-dialog.component.scss'],
    templateUrl: './add-location-set-dialog.component.html',
    standalone: false
})
export class AddLocationSetDialogComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    display = 'name';
    form: FormGroup;
    isReadOnly$ = this.authFacade.isReadOnly$;
    key = 'number';
    countryCodes = ['US', 'CA', 'PR'];
    locationSet = { tag: '', name: '' };
    locationSetTypes = [];
    name: string;
    showCreateLocationSet = false;

    constructor(
        private authFacade: AuthFacadeService,
        public dialogRef: MatDialogRef<AddLocationSetDialogComponent>,
        public locationSetService: LocationSetService,
        public tagService: TagService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.showCreateLocationSet = this.data.showCreateLocationSet;
    }



    ngOnInit(): void {
        if (this.showCreateLocationSet) {
            this.dialogRef.updatePosition({ top: '100px' });
            this.buildForm();
            this.locationSetTypes = this.data.locationSetTypes.filter(location => !location.locked);
        }
    }



    closeAfterSubmit(): void {
        const result = ['save', this.form.controls.locationSetType.value];
        this.dialogRef.close(result);
    }



    onNoClick(): void {
        this.dialogRef.close();
    }



    buildForm(): void {
        this.form = new FormGroup({
            countryCode: new FormControl(''),
            description: new FormControl(''),
            locationSetType: new FormControl(''),
            name: new FormControl(''),
            tag: new FormControl('')
        });
    }



    findTagExists(): void {
        if (this.form.controls.tag.valid) {
            this.tagService
                .getLocationSetTags(this.form.get('tag').value)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(res => {
                    if (res) {
                        this.form.controls.tag.setErrors({ tagExists: true });
                    }
                });
        }
    }



    OnSubmit(): void {
        if (this.form.valid) {
            const locationSet = {
                name: this.form.controls.name.value,
                tag: this.form.controls.tag.value,
                locationSetType: this.form.controls.locationSetType.value,
                description: this.form.controls.description.value,
                countryCode: this.form.controls.countryCode.value,
            };
            this.locationSetService
                .createLocationSet(locationSet)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(() => {
                    this.closeAfterSubmit();
                });
        }
    }



}
